/* AMPURA Band V2 PDP Fix — moved from custom_js to dedicated asset 2026-06-12 */
/* Reason: Shopify HTML balancer corrupts custom_js with literal HTML brackets in comments. */
/* This asset file is byte-stable and immune to that pipeline. */

/* ===== AMPURA BAND-V2 FIX 2026-05-29 MINIMAL ===== */
(function ampuraBandV2() {
  const VARIANT_ID = 42803837698119;
  const BTN_ID = 'ampura-real-buy-btn';
  // Upsell mapping: checkbox-ID → variant-ID (when checked, this variant gets added)
  const UPSELL_VARIANTS = {
    'upsell-upsell_wrDaTU': 42870788784199,  // 10 Jahre Garantie Launch (10-jahre-garantie-launch-hume-band, 29€/39€)
    'upsell-upsell_HHfmL4': 41820746580039,  // 10 Jahre Garantie alt (hume-band-warranty, 326€)
  };

  // Move cart-drawer to body so it escapes wrapper that breaks CSS scoping
  function rescueDrawer() {
    const cd = document.querySelector('cart-drawer');
    if (cd && cd.parentElement && cd.parentElement !== document.body) {
      document.body.appendChild(cd);
    }
  }

  // Inject our buy button (original buy-button Custom Element is broken on this PDP)
  function injectButton() {
    const c = document.querySelector('#buy-box .ante-buy-button-container');
    if (!c || c.querySelector('#' + BTN_ID)) return false;
    const btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.type = 'button';
    btn.innerHTML = '<span>JETZT SICHERN</span>';
    c.appendChild(btn);

    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      const orig = btn.innerHTML;
      btn.innerHTML = '<span>Wird hinzugefügt...</span>';
      try {
        // Build items array: main band + any checked upsell variants
        const items = [{
          id: VARIANT_ID, quantity: 1,
          properties: { _data: 'f:hume-band-2-0,t:m' }
        }];
        for (const [chkId, varId] of Object.entries(UPSELL_VARIANTS)) {
          const chk = document.getElementById(chkId);
          if (chk && chk.checked) {
            items.push({ id: varId, quantity: 1 });
            console.log('[AMPURA ATC] including upsell:', chkId, '→', varId);
          }
        }

        // SYNC pattern: POST add.js mit `sections` param → Shopify liefert frisches Drawer-HTML
        // in derselben Response zurück (race-free, kein zweiter GET der gecached sein könnte).
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        if (!r.ok) throw new Error('add failed: ' + r.status);
        const data = await r.json();

        // Replace drawer-HTML with frisch-gerendertem aus POST-Response
        const drawerHtml = data.sections && data.sections['cart-drawer'];
        if (drawerHtml) {
          const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          // The section response wraps everything in #shopify-section-cart-drawer
          const sectionWrap = doc.querySelector('#shopify-section-cart-drawer');
          const newCartDrawer = (sectionWrap || doc).querySelector('cart-drawer');
          const existingCartDrawer = document.querySelector('cart-drawer');

          if (newCartDrawer && existingCartDrawer) {
            // Replace EVERYTHING inside the cart-drawer element with the fresh inner HTML.
            // This catches any DOM structure (drawer__inner, CartDrawer, etc).
            existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
            // Copy data-attributes that drive web-component state
            for (const attr of newCartDrawer.attributes) {
              if (attr.name.startsWith('data-') || attr.name === 'class') {
                existingCartDrawer.setAttribute(attr.name, attr.value);
              }
            }
            console.log('[AMPURA ATC] drawer innerHTML replaced (' + existingCartDrawer.innerHTML.length + ' chars)');
          } else {
            console.warn('[AMPURA ATC] selector miss — newCartDrawer:', !!newCartDrawer, 'existing:', !!existingCartDrawer);
          }
        }

        // Replace cart-icon-bubble from POST-Response (no cached counter)
        const bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
        if (bubbleHtml) {
          const bubbleHost = document.querySelector('#cart-icon-bubble');
          if (bubbleHost) bubbleHost.innerHTML = bubbleHtml;
        }

        // Force-mark drawer as not-empty + open it
        const cd = document.querySelector('cart-drawer');
        if (cd) {
          cd.classList.remove('is-empty');
          cd.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
          // If the web component is a Shopify-Dawn cart-drawer, trigger its own open() if available
          if (typeof cd.open === 'function') {
            try { cd.open(); } catch (_) {}
          }
        }
      } catch (e) {
        console.error('AMPURA ATC failed:', e);
        alert('Fehler: ' + e.message);
      } finally {
        btn.disabled = false;
        btn.innerHTML = orig;
      }
    });
    return true;
  }

  // Re-fetch drawer + cart-icon after server-side state change, replace innerHTML.
  // Used after item removal / quantity change so drawer reflects new state.
  async function refreshDrawer(closeIfEmpty) {
    try {
      const r = await fetch('/cart.js?_=' + Date.now());
      const cj = await r.json();
      const sresp = await fetch('/?sections=cart-drawer,cart-icon-bubble&_=' + Date.now());
      const sec = await sresp.json();
      // Drawer
      const drawerHtml = sec['cart-drawer'];
      if (drawerHtml) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const newCD = doc.querySelector('cart-drawer');
        const existing = document.querySelector('cart-drawer');
        if (newCD && existing) {
          existing.innerHTML = newCD.innerHTML;
          for (const attr of newCD.attributes) {
            if (attr.name.startsWith('data-') || attr.name === 'class') {
              existing.setAttribute(attr.name, attr.value);
            }
          }
        }
      }
      // Bubble
      const bubbleHtml = sec['cart-icon-bubble'];
      if (bubbleHtml) {
        const bubbleHost = document.querySelector('#cart-icon-bubble');
        if (bubbleHost) bubbleHost.innerHTML = bubbleHtml;
      }
      // If empty + closeIfEmpty → close drawer
      if (closeIfEmpty && cj.item_count === 0) {
        closeDrawer();
      }
    } catch (e) {
      console.error('[AMPURA] refreshDrawer failed:', e);
    }
  }

  function closeDrawer() {
    const cd = document.querySelector('cart-drawer');
    if (cd) {
      // ONLY remove visual classes — do NOT add is-empty here (keeps items in DOM)
      cd.classList.remove('active', 'animate');
      document.body.classList.remove('overflow-hidden');
    }
  }

  // DELEGATED event handlers on document.body — survive innerHTML replacements
  function bindGlobalDrawerHandlers() {
    if (window.__ampura_drawer_bound) return;
    window.__ampura_drawer_bound = true;

    // Item remove — catches all common patterns
    document.body.addEventListener('click', async function(e) {
      const target = e.target;
      if (!target) return;
      // Find any remove/delete trigger inside cart-drawer
      const removeBtn = target.closest('cart-drawer cart-remove-button, cart-drawer .cart-remove-button, cart-drawer [data-cart-remove], cart-drawer a.cart-item__remove, cart-drawer button.cart-item__remove, cart-drawer .cart__remove, cart-drawer [aria-label*="entfern" i], cart-drawer [aria-label*="remove" i], cart-drawer [aria-label*="löschen" i]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        // Find line number
        const cartItem = removeBtn.closest('[id^="CartDrawer-Item-"], [id^="CartItem-"], cart-item, .cart-item, li.cart-item');
        let line = null;
        if (cartItem) {
          const m = cartItem.id?.match(/(?:CartDrawer-Item-|CartItem-)(\d+)/);
          if (m) line = parseInt(m[1]);
          if (!line) {
            // Fallback: index among items in drawer
            const items = [...document.querySelectorAll('cart-drawer .cart-item, cart-drawer [id^="CartDrawer-Item-"]')];
            const idx = items.indexOf(cartItem);
            if (idx >= 0) line = idx + 1;
          }
        }
        if (!line) line = 1;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          });
          await refreshDrawer(true);
        } catch (err) {
          console.error('[AMPURA] remove failed:', err);
        }
        return;
      }

      // Close button — catches drawer close trigger
      const closeBtn = target.closest('cart-drawer [aria-label*="close" i], cart-drawer [aria-label*="schlie" i], cart-drawer .drawer__close, cart-drawer .cart-drawer__close, cart-drawer button.close, cart-drawer [data-close-drawer], cart-drawer .icon-close');
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      // Overlay click — catches background overlay
      if (target.classList && target.classList.contains('drawer__overlay') ||
          target.closest('cart-drawer .drawer__overlay, .cart-drawer-overlay')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    // ESC key closes drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const cd = document.querySelector('cart-drawer.active');
        if (cd) closeDrawer();
      }
    });

    // Quantity input change → refresh drawer
    document.body.addEventListener('change', async function(e) {
      const input = e.target;
      if (!input || !input.matches) return;
      if (input.matches('cart-drawer input[name="quantity"], cart-drawer input.quantity__input')) {
        const qty = parseInt(input.value);
        const cartItem = input.closest('[id^="CartDrawer-Item-"], [id^="CartItem-"], cart-item, .cart-item');
        let line = null;
        if (cartItem) {
          const m = cartItem.id?.match(/(?:CartDrawer-Item-|CartItem-)(\d+)/);
          if (m) line = parseInt(m[1]);
        }
        if (!line) line = 1;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: qty })
          });
          await refreshDrawer(qty === 0);
        } catch (err) {
          console.error('[AMPURA] qty change failed:', err);
        }
      }
    });
  }

  // Smooth-scroll to #buy-box for any anchor pointing there
  function bindBuyboxScroll() {
    if (window.__ampura_scroll_bound) return;
    window.__ampura_scroll_bound = true;
    document.body.addEventListener('click', function(e) {
      var a = e.target && e.target.closest && e.target.closest('a[href="#buy-box"], a[href="#.buy-box"], a.scroll-down, a.buy-btn, a.hero-btn, a.accuracy-btn');
      if (!a) return;
      var target = document.getElementById('buy-box');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    rescueDrawer();
    bindGlobalDrawerHandlers();
    bindBuyboxScroll();
    if (!injectButton()) {
      const obs = new MutationObserver(() => { if (injectButton()) obs.disconnect(); });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ===== END AMPURA BAND-V2 FIX ===== */